import { LiveOrderApi } from "../../../../../../../services/Api/Organization/types";
import { getDeliveryTimeInSeconds } from "./orderDelivery";

export const getOrdersSortedByTheLowestDeliveryTime = (orders: LiveOrderApi[]) => {
	const newOrders = [...orders];
	return newOrders.sort(
		(a, b) => getDeliveryTimeInSeconds(a?.execution_at) - getDeliveryTimeInSeconds(b?.execution_at)
	);
};
